module.exports = __webpack_public_path__ + "img/categoryNavIcon.e0bc6402.svg";